import { apiGet, apiPost } from './http-client';
import type { ContextRequiredResponse, LoginContextOption, LoginSurface } from './auth-contexts';

export type RequestCallBody = {
  phone: string;
  org_slug?: string | null;
  /** Точка входа: client | trainer | staff. Сервер сохраняет раздел в заявке на вход. */
  surface?: LoginSurface;
  /** Список студий входа (для приложений с несколькими студиями). */
  org_slugs?: string[];
  /** После подтверждения звонка для нового пользователя вернуть registration_token вместо 401. */
  register?: boolean;
  /** call_mode: "callcheck" — пользователь сам звонит на номер SMS.ru. */
  call_mode?: string;
  /** Токен Yandex SmartCaptcha (когда captcha_enabled=true). */
  captcha_token?: string;
  // #__PLUSOFON_DISABLE__ — провайдер временно зафиксирован на sms_ru:
  // provider?: 'sms_ru' | 'plusofon' | string;
};

export type RequestCallResponse = {
  check_id: string;
  call_phone: string;
  call_phone_pretty: string;
  call_phone_html: string | null;
  // #__PLUSOFON_DISABLE__: provider?: 'sms_ru' | 'plusofon' | string;
  callcheck_providers?: string[];
};

export type CallStatusResponse = {
  status: 'pending' | 'confirmed' | 'expired' | 'two_factor_required' | 'context_required';
  access_token?: string | null;
  refresh_token?: string | null;
  registration_token?: string | null;
  token_type?: string;
  /** Шаг 2FA: одноразовый токен для POST /api/v1/auth/login/2fa. */
  temp_token?: string;
  expires_in?: number;
  /** status=context_required: варианты раздела и одноразовый токен выбора. */
  contexts?: LoginContextOption[];
  selection_token?: string;
};

export type CallStatusContextRequired = ContextRequiredResponse;

/** POST /api/v1/auth/request-call */
export function postRequestCall(body: RequestCallBody): Promise<RequestCallResponse> {
  return apiPost<RequestCallResponse>('/api/v1/auth/request-call', body);
}

/** GET /api/v1/auth/call-status */
export function getCallStatus(checkId: string, code?: string): Promise<CallStatusResponse> {
  const params: Record<string, string> = { check_id: checkId };
  if (code) params.code = code;
  return apiGet<CallStatusResponse>('/api/v1/auth/call-status', params);
}